import { useEffect, useState } from 'react';
import { AdMob, BannerAdSize, BannerAdPosition, BannerAdPluginEvents } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';

export default function AdBanner() {
    const [isAdLoaded, setIsAdLoaded] = useState(false);

    useEffect(() => {
        if (Capacitor.getPlatform() !== 'web') {
            initializeAdMob();
        }
    }, []);

    const initializeAdMob = async () => {
        try {
            await AdMob.initialize({});
            
            // Listen for ad load event
            AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
                setIsAdLoaded(true);
            });

            const options = {
                adId: 'ca-app-pub-3940256099942544/6300978111', // Google Test Banner ID
                adSize: BannerAdSize.BANNER,
                position: BannerAdPosition.BOTTOM_CENTER,
                margin: 0,
                isTesting: true,
            };
            
            await AdMob.showBanner(options);
        } catch (error) {
            console.error("Failed to initialize or show AdMob banner", error);
        }
    };

    // The banner floats natively above the WebView, but we add padding to our DOM so content isn't hidden.
    return isAdLoaded ? <div style={{ height: '50px', width: '100%' }} /> : null;
}
